import { Component } from '@angular/core';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { ProofDefinition } from '../../../../models/ProofDefinition';
import { Paginator } from '../../../../models/Paginator';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { GenericCrudService } from '../../../../services/generic-crud.service';
import { Filter } from '../../../../models/GenericCRUD/Filter';

@Component({
  selector: 'app-proof-definition-configuration',
  standalone: true,
  imports: [GenericCrudComponent],
  templateUrl: './proof-definition-configuration.component.html',
  styleUrls: ['./proof-definition-configuration.component.css']
})
export class ProofDefinitionConfigurationComponent {

  proofTypes: any[] = [];

  constructor(private breadcrumbService: BreadcrumbService, private crudService: GenericCrudService) {
    // this.breadcrumbService.setBreadcrumb({
    //   display_name: 'Configuración',
    //   url:'/dashboard/configuracion',
    //   items: []
    // })

    this.loadProofTypes();
  }

  loadProofTypes() {
    this.crudService.list('/config/proof-type/listAll', []).subscribe({
      next: (response) => {
        if (response.data) {
          this.proofTypes = response.data;
          this.updateSubtypeOptions();
        }
      },
      error: (error) => {
        console.error('Error loading proof types:', error);
      }
    });
  }


  updateSubtypeOptions() {
    const emptyOption = { id: null, name: 'Sin subtipo' };
    const optionsWithEmpty = [emptyOption, ...this.proofTypes];

    const subtypeField = this.formFields.find(field => field.name === 'proof_subtype_id');
    if (subtypeField) {
      subtypeField.options = optionsWithEmpty;
    }

    const subtypeFieldEdit = this.formFieldsEdit.find(field => field.name === 'proof_subtype_id');
    if (subtypeFieldEdit) {
      subtypeFieldEdit.options = optionsWithEmpty;
    }
  }

  tableColumns: GenericTableColumn[] = [
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Tipo', active: true, type: 'text', key: 'type', sort: true },
    { name: 'Permisos', active: true, type: 'text', key: 'licenses_names', sort: false },
    { name: 'Tasa', active: true, type: 'currency', key: 'rates_price', sort: false },
    { name: 'Subtipo', active: true, type: 'text', key: 'proof_subtype.name', sort: true },
    { name: 'Fecha de expiración', active: true, type: 'date', key: 'expiration_date', sort: true },
    { name: 'Observaciones', active: true, type: 'text', key: 'observations', sort: false },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    {
      name: 'type', type: 'select', label: 'Tipo', validations: 'required', optionsList: [
        { id: 'Teorico', name: 'Teorico' },
        { id: 'Abierto', name: 'Abierto' },
        { id: 'Cerrado', name: 'Cerrado' }
      ], singleSelection: true
    },
    { name: 'licenses', type: 'select', label: 'Permisos compatibles', url: '/config/license/listAll', validations: 'nullable', options: [], singleSelection: false },
    { name: 'rates', type: 'select', label: 'Tasa', validations: 'required', url: '/config/rate/listAll', options: [], singleSelection: false },
    { name: 'proof_subtype_id', type: 'select', label: 'Subtipo (Solo para teorico)', validations: 'nullable', options: [], singleSelection: true, fieldListener: 'type', subfieldListener: 'Teorico' },
    { name: 'expiration_date', type: 'date', label: 'Fecha de expiración', validations: 'nullable|date|after:today' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', validations: 'nullable|string|max:500' }
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    {
      name: 'type', type: 'select', label: 'Tipo', validations: 'required', optionsList: [
        { id: 'Teorico', name: 'Teorico' },
        { id: 'Abierto', name: 'Abierto' },
        { id: 'Cerrado', name: 'Cerrado' }
      ], singleSelection: true
    },
    { name: 'licenses', type: 'select', label: 'Permisos compatibles', url: '/config/license/listAll', validations: 'nullable', options: [], singleSelection: false },
    { name: 'rates', type: 'select', label: 'Tasa', validations: 'required', url: '/config/rate/listAll', options: [], singleSelection: false },
    { name: 'proof_subtype_id', type: 'select', label: 'Subtipo (Solo para teorico)', validations: 'nullable', options: [], singleSelection: true, fieldListener: 'type', subfieldListener: 'Teorico' },
    { name: 'expiration_date', type: 'date', label: 'Fecha de expiración', validations: 'nullable|date|after:today' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', validations: 'nullable|string|max:500' },
  ];

  form: GenericForm = {
    successTitle: 'Examen creado correctamente',
    errorTitle: 'Error al crear el examen',
    method: 'POST',
    fields: this.formFields,
    name: 'examen',
    createButtonTitle: 'Nuevo examen',
    cols: 2,
    createApiSlug: '/config/proof-definition/store',
    formTitle: 'Crear Examen',
    formButtonTitle: 'Crear',
    width: '3xl'
  };


  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'proofDefinition',
        createButtonTitle: '',
        cols: 2,
        originalUpdateApiSlug: '/config/proof-definition/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '3xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar el examen?',
      deleteRowOnResponse: true,
      actionSlug: '/config/proof-definition/delete/{{id}}',
    }
  ];

  table: GenericTable<Paginator<ProofDefinition>> = {
    columns: this.tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/proof-definition/index',
    paginate: true,
    name: 'pruebas',
    details: false,
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|observations', operator: 'like', placeholder: 'Nombre o observaciones' },
    { type: 'multiselect', key: 'type.name', operator: 'in', placeholder: 'Tipo', optionsList: [{ id: 'Cerrado', name: 'Cerrado' }, { id: 'Abierto', name: 'Abierto' }, { id: 'Teorico', name: 'Teórico' }], relation_filter_column: 'type' },
  ];

  genericCRUD: GenericCRUD<Paginator<ProofDefinition>> = {
    genericTable: this.table,
    genericForm: this.form,
    useModalForm: true,
    genericFilters: this.filters
  };
}
